import { Config, Dict, OverridedMixpanel } from "mixpanel-browser";
import {
  IAnalyticsProviderFactopry,
  IOverrideMixpanel,
} from "../../../core/ports/driven/analyticsProvider";

export const AnalyticsProviderFactory: IAnalyticsProviderFactopry = (
  mixpanel: OverridedMixpanel
) => {
  return {
    // if you want to use more function please add them then use it
    identify: (unique_id?: string) => mixpanel.identify(unique_id),
    init: (token: string, config?: Partial<Config>) =>
      (mixpanel as IOverrideMixpanel).init(token, config),
    reset: () => mixpanel.reset(),
    track: (event_name: string, properties?: Dict) =>
      mixpanel.track(event_name, properties),
    timeEvent: (event_name: string) => mixpanel.time_event(event_name),
    setPeople: (prop: Dict) => mixpanel.people.set(prop),
  };
};
